import { MathUtils } from 'three';

import { AnnoCompoundItem, AnnoInstanceItem, IAnnoItem } from '../annos';

/**
 * 按照 sourceItem 创建出需要的插值标注物
 * @param sourceItem 源标注物
 * @param begin 插值开始的帧数
 * @param end 插值结束的帧数
 * @param annotations 当前帧的标注物
 * @param trackAnnoMap 记录 trackId 对应在每一帧的标注物
 */
export const createInterpolatedAnnoItemList = (
  sourceItem: IAnnoItem,
  begin: number,
  end: number,
  trackAnnoMap: Map<AnnoInstanceItem['trackId'], Map<number, AnnoInstanceItem['name']>>,
  compoundTrackIds: IAnnoItem['trackId'][] = []
): Map<number, IAnnoItem> => {
  const label = sourceItem.label,
    attrs = sourceItem.attrs,
    trackId = sourceItem.trackId;

  const map: Map<number, IAnnoItem> = new Map();
  // i 表示帧数，从 begin 开始，到 end 结束
  for (let i = begin; i <= end; i++) {
    let newItem: IAnnoItem | null = null;
    if (sourceItem instanceof AnnoInstanceItem) {
      newItem = new AnnoInstanceItem(
        MathUtils.generateUUID(),
        label,
        { ...sourceItem.widget, data: [] }, // 插值的标注物的 widget 的 data 都是空数组 []
        {
          source: 'interpolation',
          attrs: { ...attrs },
          trackId,
        }
      );
    } else {
      let compound: string[] = [];
      for (let j = 0, l = compoundTrackIds.length; j < l; j++) {
        const trackId = compoundTrackIds[j];
        const annoName = trackAnnoMap.get(trackId)?.get(i);
        if (!annoName) break;
        compound.push(annoName);
      }
      // 对于组合标注物，如果 compound 的长度和 compoundTrackIds 的长度相等，说明这一帧的标注物都存在，可以创建组合标注物
      if (compound.length === compoundTrackIds.length) {
        newItem = new AnnoCompoundItem(MathUtils.generateUUID(), label, compound, {
          source: 'manual',
          attrs: { ...attrs },
          trackId,
        });
      }
    }
    newItem && map.set(i, newItem);
  }
  return map;
};
